/**
 * FacetWP Pagination Scroll Module
 * Scrolls to the facetwp-template when pagination changes
 */

export function initFacetwpPaginationScroll() {
    let isInitialLoad = true;
    let lastPaginationPage = 1;
    
    // Listen for FacetWP refresh events
    document.addEventListener('facetwp-loaded', function() {
        // Skip scrolling on initial page load
        if (isInitialLoad) {
            isInitialLoad = false;
            // Get initial pagination page
            const paginationElement = document.querySelector('.facetwp-pager');
            if (paginationElement) {
                const currentPageElement = paginationElement.querySelector('.facetwp-page.active');
                if (currentPageElement) {
                    lastPaginationPage = parseInt(currentPageElement.textContent) || 1;
                }
            }
            return;
        }
        
        // Check if pagination changed
        const paginationElement = document.querySelector('.facetwp-pager');
        if (paginationElement) {
            const currentPageElement = paginationElement.querySelector('.facetwp-page.active');
            if (currentPageElement) {
                const currentPage = parseInt(currentPageElement.textContent) || 1;
                
                // Only scroll if pagination page changed
                if (currentPage !== lastPaginationPage) {
                    lastPaginationPage = currentPage;
                    
                    // Find the facetwp-template element
                    const facetwpTemplate = document.querySelector('.facetwp-template');
                    
                    if (facetwpTemplate) {
                        // Smooth scroll to the template
                        facetwpTemplate.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }
            }
        }
    });
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initFacetwpPaginationScroll); 